import { render } from "./privateNotes.vue?vue&type=template&id=431a7bac"
import script from "./privateNotes.vue?vue&type=script&lang=js"
export * from "./privateNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__